export class PuntoCliente {

    cod_cliente: number;
    gid: number;
    grupo: string;
    grupo_id: number;
    icono: string;
    id_icono: number;
    latitud: number;
    longitud: number;
    nombre: string;
    radio: number;
    tipo_punto: string;
    tipo_punto_id: number;
    checked: boolean;

    constructor(data: any) {
        this.cod_cliente = data['cod_cliente'];
        this.gid = data['gid'];
        this.grupo = data['grupo'];
        this.grupo_id = data['grupo_id'];
        this.icono = data['icono'];
        this.id_icono = data['id_icono'];
        this.latitud = data['latitud'];
        this.longitud = data['longitud'];
        this.nombre = data['nombre'];
        this.radio = data['radio'];
        this.tipo_punto = data['tipo_punto'];
        this.tipo_punto_id = data['tipo_punto_id'];
        this.checked = (data['checked']) ? data['checked'] : false;
    }

}